;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .filter('longDateFilter', function ($filter) {
      return function (date) {
        const newDate = moment(date)
        return newDate.format('dddd DD MMM - HH:mm')
      }
    })
})()
